export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M15.476 4.48a.75.75 0 0 1 1.298.75l-3.476 6.02h6.952a.75.75 0 0 1 0 1.5h-6.952l3.476 6.02a.751.751 0 0 1-1.298.75L12 13.498l-3.476 6.02a.75.75 0 1 1-1.298-.75l3.475-6.02H3.75a.75.75 0 0 1 0-1.5h6.951L7.226 5.23a.75.75 0 1 1 1.298-.75L12 10.5l3.476-6.02Z"/>
</svg>`;
